import Media from 'react-media';
import { Card, Heading, Stack, Inline, vars } from '@etg/wings';
import { StackedIcon, DangerousHtmlContent, Icon } from '@eti/components';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';

const stackStyles = css`
  margin-block: 24px;
`;

const stackedIconStyles = css`
  height: 48px;
  width: 48px;
`;

const textStyles = css`
  color: ${vars.colors.signal.positive.dark};
  font-size: 0.875rem;
  font-weight: 700;

  @media ${mediaQueries.medium.up} {
    font-size: 1rem;
  }
`;

const wrapperStyles = css`
  justify-content: space-between;
  width: 100%;
`;

const TravelerDetailsSelfTransferGuarantee = () => {
  const { t } = useTranslation();
  const dataTestId = 'self-transfer-guarantee';

  return (
    <Stack className={stackStyles} data-testid={`${dataTestId}-container`} spacing={16}>
      <Heading data-testid={`${dataTestId}-header`} level={2}>
        {t('TravelerDetails.SelfTransfer.Product.Header')}
      </Heading>
      <Card>
        <Media query="(min-width: 376px)">
          {(matches) =>
            matches ? (
              <Inline alignY="center" noWrap spacing={16}>
                <div>
                  <StackedIcon
                    className={stackedIconStyles}
                    icons={[
                      { id: 'circle', size: '48px', color: `${vars.colors.signal.positive.dark}` },
                      { id: 'self-transfer', color: '#fff', width: '60%' },
                    ]}
                  />
                </div>
                <Inline alignY="center" className={wrapperStyles} noWrap>
                  <Stack spacing={8}>
                    <Heading data-testid={`${dataTestId}-title`} level={3}>
                      {t('TravelerDetails.SelfTransferGuarantee.Product.Label')}
                    </Heading>
                    <DangerousHtmlContent
                      content={t('TravelerDetails.SelfTransferGuarantee.Product.Description.Text')}
                      dataTestId={`${dataTestId}-description`}
                    />
                  </Stack>
                  <p className={textStyles} data-testid={`${dataTestId}-included-text`}>
                    {t('TravelerDetails.SelfTransferGuarantee.Product.Included.Text')}
                  </p>
                </Inline>
              </Inline>
            ) : (
              <Stack spacing={8}>
                <Heading data-testid={`${dataTestId}-title`} level={3}>
                  <Inline alignY="center" noWrap>
                    <div>
                      <Icon
                        color={vars.colors.signal.positive.dark}
                        id="self-transfer"
                        size="22px"
                      />
                    </div>
                    {t('TravelerDetails.SelfTransferGuarantee.Product.Label')}
                  </Inline>
                </Heading>
                <Stack align="end">
                  <DangerousHtmlContent
                    content={t('TravelerDetails.SelfTransferGuarantee.Product.Description.Text')}
                    dataTestId={`${dataTestId}-description`}
                  />
                  <p className={textStyles} data-testid={`${dataTestId}-included-text`}>
                    {t('TravelerDetails.SelfTransferGuarantee.Product.Included.Text')}
                  </p>
                </Stack>
              </Stack>
            )
          }
        </Media>
      </Card>
    </Stack>
  );
};

export default TravelerDetailsSelfTransferGuarantee;
